import { memo, useState } from 'react';
import { Skeleton } from '@monksflow/monks-ui';
import { Modal } from '../../Modal';

import type { ImagePreviewProps } from './ImagePreview.types';

export const ImagePreview = memo(({ open, onClose, filename, url }: ImagePreviewProps) => {
  const [resourceLoading, setResourceLoading] = useState(true);

  return (
    <Modal open={open} onClose={onClose}>
      {resourceLoading && (
        <>
          <Skeleton className="mb-2 h-7.5 w-25" />
          <Skeleton className="h-100" onClick={() => setResourceLoading(false)} />
        </>
      )}
      {!resourceLoading && (
        <h6 className="text-xl font-medium break-all" data-testid="modal-title">
          {filename}
        </h6>
      )}
      <img
        src={url}
        alt={filename}
        onLoad={() => setResourceLoading(false)}
        className={resourceLoading ? 'hidden' : 'block'}
      />
    </Modal>
  );
});

ImagePreview.displayName = 'ImagePreview';
